//
//
//
//
//
//
//
//
//
export default {
  name: 'Example',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created Example');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated Example');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};